import axios from 'axios'
import moment from 'moment'
import toast from 'react-hot-toast'
import { takeEvery, put, all, call } from 'redux-saga/effects'
import { application } from '../../../../../../redux/store'
import { showBuildings, showSmsPreview } from './slice'
import { ToBuildingSmsTypes } from './types'

function* showBuildingsSmsHandler({ payload }) {
  const response = yield call(() =>
    axios.post(`${application.api}/buildings`, {payload,all:true})
  )
  yield put(showBuildings(response.data.data))
}
function* sendSmsPreviewHandler({ payload }) {
  payload.sms_template_id = payload.sms_template.id
  try {
    const response = yield call(() =>
      axios.post(`${application.api}/building/sms/preview`, {
        all_data: payload?.all_data,
        future_date: {
          hour: parseInt(payload.hour),
          minute: payload.minute,
          start_date: payload?.date,
        },
        is_future_date: payload?.is_future_date,
        message: payload?.message,
        name: payload?.name,
        national_id: payload?.national_id,
        not_sending: payload?.not_sending,
        phone: payload?.phone,
        sending: payload?.sending,
        sms_template_id: payload?.sms_template.id,
      })
    )
    yield put(showSmsPreview(response.data.data))
  } catch (error) {
    toast.error(error.response.data.description)
  }
}
function* sendSmsHandler({ payload }) {
  try {
    const response = yield call(() =>
      axios.post(`${application.api}/building/sms/send`, {
        all_data: payload?.all_data,
        future_date: {
          hour: parseInt(payload.hour),
          minute: payload.minute,
          start_date: payload?.date,
        },
        is_future_date: payload?.is_future_date,
        message: payload?.message,
        name: payload?.name,
        national_id: payload?.national_id,
        not_sending: payload?.not_sending,
        phone: payload?.phone,
        sending: payload?.sending,
        sms_template_id: payload?.sms_template.id,
      })
    )
    if (payload.continually) {
      yield call(() =>
        axios.post(`${application.api}/sms/jobs`, {
          hour: parseInt(payload.hour),
          minute: payload.minute,
          job_type: 0,
          last_date: payload.continually_date,
          message: payload.message,
          name: 'test',
          resident_ids: payload.sending,
        })
      )
    }
    toast.success(response.data.description)
  } catch (error) {
    toast.error(error.response.data.description)
  }
}
export function* ToBuildingsSmsSagas() {
  yield all([
    takeEvery(ToBuildingSmsTypes.SHOW_SMS_BUILDING, showBuildingsSmsHandler),
    takeEvery(
      ToBuildingSmsTypes.SEND_SMS_BUILDING_PREVIEW,
      sendSmsPreviewHandler
    ),
    takeEvery(ToBuildingSmsTypes.SEND_SMS_BUILDING, sendSmsHandler),
  ])
}
